module.exports = __webpack_public_path__ + "static/media/LWM.76095b27.PNG";